<template>
  <el-dialog class="whd-percomm" title="明细" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="70%">
    <div class="whd-percomm-list">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!--<span>{{ props.row.name }}</span>-->
            <el-table :data="props.row.goods_list" style="width: 100%">
              <el-table-column prop="date" label="商品图片" width="180">
                <template slot-scope="scope">
                  <img :src="scope.row.goods_thumb" alt="" width="50" height="50">
                </template>
              </el-table-column>
              <el-table-column prop="goods_name" label="商品名称" width="180"></el-table-column>
              <el-table-column prop="price_num" label="单价/数量"></el-table-column>
              <el-table-column prop="all_price" label="商品总价"></el-table-column>   
              <el-table-column prop="amount" label="应付"></el-table-column>   
              <el-table-column prop="discount" label="优惠"></el-table-column>                                                
              <el-table-column prop="user_commission" label="分销佣金"></el-table-column>
              <el-table-column prop="consignee" label="收货人"></el-table-column>     
              <el-table-column prop="order_status" label="状态"></el-table-column>                               
              <el-table-column prop="sale_discount" label="售后扣减数量"></el-table-column>
              <el-table-column prop="dis_commission" label="扣减佣金"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="order_sn"></el-table-column>
        <el-table-column label="完成时间" prop="finish_time"></el-table-column>
      </el-table>
    </div>
  </el-dialog>   
</template>>

<script>
import api from "@/api.js";
export default {
  name: "withdrawalDetail",
  props: ["visible","index","employeeId"],
  data() {
    return{
      dialogVisible: false,
      tableData: []
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (this.dialogVisible) {
        this.InitFn()     
      }
    }
  },
  methods: {
    InitFn() {
      this.axios
          .post(api.withdraw_detail, {
            withdraw_id: this.employeeId,
            who: this.index
          })
          .then(response => {
            if (response.data.code == 0) {
              this.tableData = response.data.info.order_list;
            } else {
            }
          })
          .catch(response => {
          });
    }
  }
}
</script>